module.exports = __webpack_public_path__ + "fonts/Roboto-ThinItalic.ttf?35a9c89aff1396595ad345e378a32aca";